import { render, staticRenderFns } from "./leftArrowSvg.vue?vue&type=template&id=1ead65e2&"
import script from "./leftArrowSvg.vue?vue&type=script&lang=js&"
export * from "./leftArrowSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports